import { type ReactNode } from 'react';

import { type Aba, Tabs } from '@/ui/primitives/tabs';

interface DetalheEmAbasProps {
  /** Resumo fixo acima das abas (identidade do registro). */
  resumo: ReactNode;
  abas: readonly Aba[];
  rotulo: string;
  aba?: string;
  aoMudarAba?: (aba: string) => void;
}

/** Página/painel de detalhe: identidade no topo, seções em abas. */
export function DetalheEmAbas({ resumo, abas, rotulo, aba, aoMudarAba }: DetalheEmAbasProps) {
  return (
    <div className="grid gap-5">
      {resumo}
      <Tabs
        abas={abas}
        rotulo={rotulo}
        {...(aba === undefined ? {} : { valor: aba })}
        {...(aoMudarAba ? { aoMudar: aoMudarAba } : {})}
      />
    </div>
  );
}
